/**
 * Balasz 2024-07-20
 * Custom Routes Configuration
 *
 * These are custom routes that are defined outside of React Admin's standard resource definitions.
 * Other resources in this application are defined as React Admin resources and are present in the
 * React Admin standard definitions in src/index.js. These custom routes are used for pages that
 * don't follow the standard CRUD pattern but provide specialized functionality.
 *
 * Standard React Admin resources are defined in the <Resource> components in src/index.js
 * Custom routes are defined in the <CustomRoutes> section in src/index.js
 */
export const customRoutes = {
  ACTIVE_EVENTS: '/active-events',
  PAST_EVENTS: '/past-events',
  SALE_REPORT: '/sale-report',
  PUSH_NOTIFICATIONS: '/push-notifications',
  FEATURED_VENUES_ORDER: '/featured-venues-order',
  EVENT_HOME_PLACEMENTS: '/events-v2/:id/home-placements',
  SEAT_OPS: '/seat-ops',
  PENDING_EVENTS: '/pending-events',
  MAGIC_LOGIN: '/magic-login',
  DEEPL_SETTINGS: '/deepl-settings',
  LOGIN_SETTINGS: '/login-settings',
  LAYOUTS_V2: '/layouts-v2',
  LAYOUTS_V2_CREATE: '/layouts-v2/create',
  LAYOUTS_V2_EDIT: '/layouts-v2/:id',
  LAYOUTS_V2_VIEW: '/layouts-v2/:id/view',
};

export default customRoutes;
